export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-power-1cfc2f23cf575ab428dccbeea29d1d1d.svg";